import React, { useContext, useEffect, useState } from "react";
import {
  IonPage,
  IonRow,
  IonCol,
  IonContent,
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonGrid,
  IonItem,
  IonSegment,
  IonSegmentButton,
  IonLabel,
} from "@ionic/react";
import { Auth } from "aws-amplify";
import { ApplicationContext, ProviderContext } from "../ApplicationState";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import "./Home.css";
import jwt_decode from "jwt-decode";
import UsersComponent from "../components/UsersComponent";
import TotalReadingsChart from "../components/Charts/TotalReadingsChart";
import DrawPieChart from "../components/Charts/UsersCountChart";
import GroupReadingsComponent from "../components/GroupReadingsComponent";
import DrawLineChart from "../components/Charts/MeasurementChart";
import MeasurementChart from "../components/Charts/MeasurementChart";
import UsersCountChart from "../components/Charts/UsersCountChart";
import * as Helpers from "../services/Helpers";
import TotalReadingsPieChart from "../components/Charts/TotalReadingsPieChart";
import GroupedReadingMethodChart from "../components/Charts/GroupedReadingMethodChart";
import { useBreachThreshold } from "../components/BreachThreshold/useBreachThreshold";
import CircularProgress from "@mui/material/CircularProgress";
import { Route, Switch } from "react-router-dom";
import ConfigurationPage from "../components/Layout/ConfigurationPage";
import LayoutsPage from "../components/Layout/LayoutsPage";
import { fetchDashboardItems, updateLayout } from "../context/reducer/Layoutreducer";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../context/store";
import { State } from "ionicons/dist/types/stencil-public-runtime";
import { LoadingState } from "../types";
import { Stack } from "@mui/material";
import DashboardContent, { getFromLS } from "../components/Layout/DashboardContent";
import EMRReadings from "./Readings/EMRReadings";

const logout = () => {
  Auth.signOut();
};

const API_KEY = "<YOUR_API_KEY_HERE>";

const getDecodedAccessToken = (token: string) => {
  try {
    return jwt_decode(token);
  } catch (Error) {
    return null;
  }
};

const Home: React.FC<any> = (props) => {
  const { userState } = useContext(ApplicationContext);
  const { providerState } = useContext(ProviderContext);
  const [selectedDefaults, setSelectedDefaults] = useState('Medline Dashboard')

  // const { row, columns, deleteRow } = useBreachThreshold();
  const status = useSelector((state: RootState) => state.layoutViewComponent);
  const dispatch: AppDispatch = useDispatch()

  const [clinRepoLogin, setClinRepoLogin] = useState('')

  useEffect(() => {
    const loginSessionName = localStorage.getItem("LOGIN_NAME")

    const data = { userState, providerState }
    const savedLayout = getFromLS(userState.authenticatedUser.username + "_" + providerState.providerId, "layouts");

    if (savedLayout) {
      // Update the Redux state with the saved layout
      dispatch(
        updateLayout({
          views: [
            {
              componentLayout: savedLayout,
            },
          ],
          components: savedLayout.map((layout) => layout.component), // Map components if needed
        })
      );
    } else {
      // Fetch layout from backend if no saved layout exists
      const data = { userState, providerState };
      dispatch(fetchDashboardItems(data));
    }
    setClinRepoLogin(loginSessionName)
    // dispatch(fetchDashboardItems(data))
  }, [providerState, dispatch])



  return (
    <IonPage style={{ backgroundColor: 'white' }}>
      <Header />
      <IonContent>
        {/* <LayoutProvider> */}

        <div className="container">

          {/* {
          clinRepoLogin === 'CLIN_REPO' && (
            <IonSegment
              value={selectedDefaults}
              mode="ios"
              style={{ height: 50, width: '98%', margin: 10 }}
              onIonChange={e => {
                if (e.detail.value) {
                  setSelectedDefaults(e.detail.value);
                }
              }
              }
            >
              <IonSegmentButton value='Medline Dashboard'>
                <IonLabel style={{ fontWeight: 'bold', fontSize: 20 }}>Medline Dashboard</IonLabel>
              </IonSegmentButton>


              <IonSegmentButton value='EMR Dashboard'>
                <IonLabel style={{ fontWeight: 'bold', fontSize: 20 }}>EMR Dashboard</IonLabel>
              </IonSegmentButton>

            </IonSegment>

          )
        } */}


          {/* <div className="container">
          {/* <Switch>
                        <Route path="/configuration/:id" component={ConfigurationPage} />
                        <Route path="/" component={DashboardContent} />
                      </Switch> */}
          <Route path="/" component={DashboardContent} />
        </div>


        {/* {selectedDefaults === 'Medline Dashboard' &&
          <div className="container">
            <DashboardContent />
           
          </div>
        }

        {selectedDefaults === 'EMR Dashboard' &&
          <div className="container">
            <EMRReadings />

          </div>
        } */}

        {/* </LayoutProvider> */}
      </IonContent>

      {/* <Footer /> */}
    </IonPage>
  );
};

export default Home;


